import { NgModule } from '@angular/core';
import { PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PouchService } from './services/pouch-service';

const routes: Routes = [
  {
    path: 'ActivateOfflinePage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./activate-offline/activate-offline.module').then((m) => m.ActivateOfflinePageModule),
  },
  {
    path: 'AddEntityPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./add-entity/add-entity.module').then((m) => m.AddEntityPageModule),
  },
  {
    path: 'AddPaymentPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./add-payment/add-payment.module').then((m) => m.AddPaymentPageModule),
  },
  {
    path: 'AddSettingPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./add-setting/add-setting.module').then((m) => m.AddSettingPageModule),
  },
  {
    path: 'ConflictsManagerPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./conflicts-manager/conflicts-manager.module').then((m) => m.ConflictsManagerPageModule),
  },
  {
    path: 'RestorePage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./restore/restore.module').then((m) => m.RestorePageModule),
  },
  {
    path: 'EntitysPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./entitys/entitys.module').then((m) => m.EntitysPageModule),
  },
  {
    path: 'ChatPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./chat/chat.module').then((m) => m.ChatPageModule),
  },
  {
    path: 'HtmlEditorPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./htmleditor/htmleditor.module').then((m) => m.HtmlEditorPageModule),
  },
  {
    path: 'UserPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./user/user.module').then((m) => m.UserPageModule),
  },
  {
    path: 'UserTypesPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./user-types/user-types.module').then((m) => m.UserTypesPageModule),
  },
  {
    path: 'ForgotPasswordPage',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./forgot-password/forgot-password.module').then((m) => m.ForgotPasswordPageModule),
  },
  {
    path: 'LoginPage',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'LoginUserPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./login-user/login-user.module').then((m) => m.LoginUserPageModule),
  },
  {
    path: 'PaymentsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./payments/payments.module').then((m) => m.PaymentsPageModule),
  },
  {
    path: 'PreloadPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./preload/preload.module').then((m) => m.PreloadPageModule),
  },
  {
    path: 'ReportsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./reports/reports.module').then((m) => m.ReportPageModule),
  },
  {
    path: 'SignupPage',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./signup/signup.module').then((m) => m.SignupPageModule),
  },
  {
    path: 'SettingsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsPageModule),
  },
  {
    path: 'ViewAllEntitiesPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./view-all-entities/view-all-entities.module').then((m) => m.ViewAllEntitiesPageModule),
  },
  {
    path: 'SystemSettingsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./system-settings/system-settings.module').then((m) => m.SystemSettingsPageModule),
  },
  {
    path: 'PreloadPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./preload/preload.module').then((m) => m.PreloadPageModule),
  },
  {
    path: 'CalendarPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./calendar/calendar.module').then((m) => m.CalendarPageModule),
  },
  {
    path: 'CustomerManagementPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./customer_management/customer_management.module').then((m) => m.CustomerManagementPageModule),
  },
  {
    path: 'FormPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./form/form.module').then((m) => m.FormPageModule),
  },
  {
    path: 'FileViewerPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./fileviewer/fileviewer.module').then((m) => m.FileViewerPageModule),
  },
  {
    path: 'BillingPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./billing/billing.module').then((m) => m.BillingPageModule),
  },
  {
    path: 'ZoomPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./zoom/zoom.module').then((m) => m.ZoomModule),
  },
  {
    path: 'ZoomConnectPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./zoom-connect/zoom-connect.module').then((m) => m.ZoomConnectPageModule),
  },
  {
    path: 'PrescriptionManagementPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./prescription-management/prescription-management.module').then((m) => m.PrescriptionManagementPageModule),
  },
  {
    path: 'PrescriptionsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./prescriptions/prescriptions.module').then((m) => m.PrescriptionsPageModule),
  },
  {
    path: 'DrugDictionaryPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./drug-dictionary/drug-dictionary.module').then((m) => m.DrugDictionaryPageModule),
  },
  {
    path: 'PrintEntityPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-entity/print-entity.module').then((m) => m.PrintEntityPageModule),
  },
  {
    path: 'PrintReceiptPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-receipt/print-receipt.module').then((m) => m.PrintReceiptPageModule),
  },
  {
    path: '**',
    loadChildren: () => import('./preload/preload.module').then((m) => m.PreloadPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router, private db: PouchService) {
    this.router.config.unshift({
      path: 'SignupPage',
      loadChildren: () => import('./signup/signup.module').then((m) => m['SignupPageModule']),
    });
  }
}
